<template>
  <vs-alert active="true" class="refund-scenario-alert" :color="content.color">
    <div class="refund-scenario-alert__content">
      <h5 class="mb-2">{{ content.title }}</h5>
      <p class="mb-0">{{ content.description }}</p>
    </div>
  </vs-alert>
</template>

<script>
import { getRefundCompensationScenarioContent } from '../utils/refundCompensation';

export default {
  name: 'EndorsementRefundScenarioAlert',
  props: {
    scenario: {
      type: String,
      default: null,
    },
  },
  computed: {
    content() {
      return getRefundCompensationScenarioContent(this.scenario);
    },
  },
};
</script>

<style lang="scss" scoped>
.refund-scenario-alert__content {
  h5 {
    color: #1f2937;
  }

  p {
    color: #4b5563;
    line-height: 1.5;
  }
}
</style>
